import { useRecordWebcam } from "react-record-webcam";
import stopiIcon from "../../Assets/Icons/stopButton.svg";
import playIcon from "../../Assets/Icons/playButton.svg";
import startIcon from "../../Assets/Icons/startButton.svg";
import { useState } from "react";
import { Button, Popconfirm } from "antd";
import { Progress, Modal } from "antd";
import browserWindowIcon from "../../Assets/Icons/Browserwindow.png";
import { useLocation, useParams } from "react-router-dom";
import { Fa0 } from "react-icons/fa6";
import CandodateService from "../../Service.js/CandidateService";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Spin } from "antd";
import lifhtIcon from "../../Assets/Icons/lightIcon.svg";
import { useEffect } from "react";
import { turnOffWebCam } from "../../Utils/utils";
import CustomeVideoControler from "../../Components/CommonCommponents/videoPlayer/CustomeVideoControler";
import { ExclamationCircleFilled } from "@ant-design/icons";
const { confirm } = Modal;

const CandidaetVideo = () => {
  const { videoId } = useParams();
  const location = useLocation();
  const [isVideo, setIsVideo] = useState(false);
  const [isPreview, setIsPreview] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [isConfirm, setIsConfirm] = useState(false);
  const [isprogress, setProgress] = useState(false);
  const [options, setOptions] = useState();
  const [recordStartTime, setRecordStartTime] = useState("");
  const navigate = useNavigate();

  // const getBrowserType = () => {
  //     const userAgent = navigator.userAgent;
  //     if (userAgent.indexOf("Chrome") !== -1) return "Chrome";
  //     if (userAgent.indexOf("Firefox") !== -1) return "Firefox";
  //     // Add more conditions for other browsers if needed
  //     return "Unknown";
  // }
  // useEffect(() => {
  //     const browserType = getBrowserType();
  //     console.log("testbrowserType",browserType);
  //     // Conditionally set mimeType based on the browser type
  //     const mimeType = browserType === 'Firefox' ? 'video/webm;codecs=vp8' : 'video/mp4';
  //     const optionss = { fileName: "yourFileName", fileType: "yourFileType", mimeType };
  //     setOptions(optionss)
  //   }, []);
  const {
    activeRecordings,
    createRecording,
    openCamera,
    closeCamera,
    startRecording,
    stopRecording,
    clearAllRecordings,
    clearPreview,
    cancelRecording,
  } = useRecordWebcam();

  const stopRecordingAndCloseCamera = async () => {
    if (isVideo && activeRecordings.length > 0) {
      const recordingId = activeRecordings[0].id;
      try {
        console.log("Attempting to stop recording and close camera...");
        // Log the recording ID to ensure it's correct
        console.log("Recording ID:", recordingId);
        await stopRecording(recordingId);
        await closeCamera(recordingId);
        setIsVideo(false);
        turnOffWebCam();
      } catch (error) {
        console.error("Error in stopRecordingAndCloseCamera:", error);
        toast.error("Failed to stop recording");
      }
    }
  };

  useEffect(() => {
    const handleBeforeUnload = async (event) => {
      if (isVideo) {
        event.preventDefault();
        event.returnValue = ""; // Required for Chrome
        try {
          navigate(0);
          await stopRecordingHandler(activeRecordings[0]);
        } catch (error) {
          console.error("Error handling beforeunload event:", error);
        }
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      if (isVideo) {
        navigate(0);
        // confirm({
        //   title: "Do you want to delete these items?",
        //   icon: <ExclamationCircleFilled />,
        //   content: "Some descriptions",
        //   onOk() {
        //     navigate(0);
        //   },
        //   onCancel() {
        //     console.log("Cancel");
        //   },
        // });
        // stopRecordingHandler(activeRecordings[0]).catch((error) => {
        //   console.error("Error cleaning up beforeunload event:", error);
        // });
      }
    };
  }, []);

  useEffect(() => {
    if (isVideo) {
      navigate(0);
      stopRecordingHandler(activeRecordings[0]).catch((error) => {
        console.error("Error handling route change:", error);
      });
    }
  }, [location.pathname]);

  const startRecordingHandler = async (options) => {
    setIsOpen(false);
    try {
      setIsVideo(true);
      const recording = await createRecording();
      if (!recording) return;
      const constraints = {
        audio: true, // or provide specific audio constraints if needed
      };
      await openCamera(recording.id, { video: constraints });
      await startRecording(recording.id);
      setRecordStartTime(Date.now());
      setTimeout(() => {
        console.log("stopping", recording.id);
        stopRecordingHandler(recording.id);
      }, 120000);
      // await new Promise((resolve) => setTimeout(resolve, 3000));
      // await stopRecording(recording.id);
    } catch (error) {
      console.error({ error });
    }
  };

  const stopRecordingHandler = async (recording) => {
    console.log("activeRecordings", recording?.id);
    const EndTime = Date.now();
    const recorded_time = (EndTime - recordStartTime) / 1000;
    if (recorded_time >= 30) {
      let recordingId = recording?.id;
      setIsPreview(true);
      // await stopRecording(recordingId);
      // await closeCamera(recordingId);
      // setIsVideo(false)
      try {
        await stopRecording(recordingId);
        await closeCamera(recordingId);
        setIsVideo(false);
        turnOffWebCam();
      } catch (error) {
        //toast.error("Failed to stop recording");
      }
    } else {
      toast.error("Video Length should be minimum 30 seconds");
    }
  };
  const playREcordings = (recording) => {
    const video = recording.previewRef.current;

    if (video) {
      if (video.readyState >= 2) {
        // If the video is loaded and ready to play (readyState >= 2)
        video.pause();
        video.currentTime = 0;
        video.play();
      }
    }
  };
  const handelDelete = async (recordingId, recording) => {
    await clearAllRecordings();
    setIsOpen(true);
    setIsPreview(false);
  };
  const recorderedVideo = async (recording) => {
    let blob = await fetch(recording.objectURL).then((r) => r.blob());
    console.log("testrecording", blob);
    setProgress(true);
    await CandodateService.upadeProfileVideo(blob, videoId)
      .then(
        (oResponse) => {
          console.log("oResponse", oResponse);
          toast.success("Successfully Video is Saved!");
          navigate("/profile");
        },
        (error) => {
          console.log("loginError", error);
        }
      )
      .catch((err) => {
        console.log(err);
        setProgress(true);
        toast.error("Failed To Upload");
      });
  };
  console.log("activeRecordings", activeRecordings);
  const controls = document.getElementById("controls");
  console.log(controls, "controlscontrols");
  return ( 
    <>
      <div className="pageContent w-full scrollbar-hide">
        {isOpen && (
          <div className="flex flex-wrap items-center justify-center mb-10">
            <div className="mt-10">
              <div className="">
                <video controls 
                disablePictureInPicture 
                controlsList="nodownload nofullscreen noremoteplayback" 
                ref={null} className="h-[450px] w-full" style={{ transform: "scaleX(-1)" }}  />
              </div>

              <div className="h-[88px] w-full rounded-xl bg-[#161616] flex flex-wrap items-center justify-center">
                <button>
                  <img
                    src={startIcon}
                    onClick={startRecordingHandler}
                    alt="startIcon"
                  />
                </button>
              </div>
              <div className="flex flex-wrap mt-4">
                <img src={lifhtIcon} alt="" className="" />
                <p className="text-center font-Poppins text-gray-800 dark:text-gray-200 text-base font-medium px-4">
                  Video Length: Minimum 30 sec to Maximum 2 min
                </p>
              </div>
            </div>
          </div>
        )}

        {activeRecordings.map((recording) => (
          <div>
            <div key={recording.id} className="mt-10">
              {isVideo && (
                <div className="flex flex-wrap items-center justify-center">
                  <div className="">
                    <div className="video-wrapper">
                      <video
                        // controls
                        disablePictureInPicture 
                     controlsList="nodownload nofullscreen noremoteplayback" 
                        ref={recording.webcamRef}
                        className="h-[450px] w-full bg-slate-800"
                        muted
                        style={{ transform: "scalex(-1)" }}
                      />
                      <CustomeVideoControler videoRef={recording.webcamRef} />
                    </div>

                    <div className="h-[88px] w-full rounded-xl bg-[#161616] flex flex-wrap items-center justify-center">
                      <button>
                        <img
                          src={stopiIcon}
                          onClick={() => stopRecordingHandler(recording)}
                          alt="stopiIcon"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              )}


              
              {isPreview && recording.previewRef && (
                <div className="flex flex-wrap items-center justify-center ">
                  <div className="">
                    <div className="">
                      <video
                      disablePictureInPicture 
                      controlsList="nodownload nofullscreen noremoteplayback" 
                        controls
                        ref={recording.previewRef}
                        className="h-[450px] w-full"
                        style={{ transform: "scaleX(-1)" }} 
                      />
                    </div>

                    <div className="h-[88px] w-full bg-[#161616] rounded-xl flex flex-wrap items-center justify-center">
                      <button>
                        <img
                          src={playIcon}
                          onClick={() => playREcordings(recording)}
                          alt="stopiIcon"
                        />
                      </button>
                    </div>
                    <div className="flex flex-wrap justify-end mt-6 mb-10">
                      <div className="flex flex-wrap justify-between">
                        <div className="px-2">
                          <Button
                            onClick={() => handelDelete(recording.id)}
                            className="rounded-full text-[#3E94EB] text-base font-semibold font-poppins border border-[#3E94EB] "
                          >
                            Delete Video
                          </Button>
                        </div>
                        <div>
                          <Button
                            onClick={() => setIsConfirm(true)}
                            className="rounded-full text-white bg-[#1C4980] text-base font-semibold"
                          >
                            Upload Video
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {isConfirm && (
                <Modal
                  title={null}
                  open={isConfirm}
                  width={703}
                  onCancel={() => setIsConfirm(false)}
                  footer={null}
                >
                  {isprogress ? (
                    <div className="pt-36 pb-36">
                      <Spin tip="Uploading" size="small">
                        <div className="content" />
                      </Spin>
                    </div>
                  ) : (
                    <div className="flex flex-wrap items-center justify-center mt-10">
                      <div>
                        <div className="">
                          <img
                            src={browserWindowIcon}
                            alt="browserWindowIcon"
                          />
                        </div>
                        <div className="flex flex-wrap items-center justify-center mt-4 px-6">
                          <p className="text-black font-poppins text-2xl font-bold">
                            Are you sure?
                          </p>
                        </div>
                        <div className="flex flex-wrap items-center justify-center mt-4 px-6">
                          <p className="text-gray-600 text-center font-poppins text-base font-normal">
                            {" "}
                            Are you sure want to upload this <br />
                            video for profile video ?
                          </p>
                        </div>
                        <div className="flex flex-wrap items-center justify-center mt-16 px-6 mb-16">
                          <div className="flex flex-wrap justify-between">
                            <div className="px-6">
                              <Button
                                onClick={() => recorderedVideo(recording)}
                                className="rounded-full text-[#3E94EB] text-base font-semibold font-poppins border border-[#3E94EB] "
                              >
                                Yes
                              </Button>
                            </div>
                            <div>
                              <Button
                                onClick={() => setIsConfirm(false)}
                                className="rounded-full text-white bg-[#1C4980] text-base font-semibold"
                              >
                                No
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </Modal>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
export default CandidaetVideo;
